import * as React from "react";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Sidebar from "../scenes/global/sidebar";
import RouterProvider from "../Routes/routerProvider";
import Login from "../scenes/auth/loginPage";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ForgotPassword from "../scenes/auth/forgotPw";
import ResetPassword from "../scenes/auth/resetPw";
import FinishTable2 from "../scenes/Pages/RaceDay/Finish-Time-Entry/ManualTimesEntryTab/FinishTable2";
import FinishRaceManager from "../scenes/Pages/RaceDay/Finish-Time-Entry/ManualTimesEntryTab/app_components_race-manager";
import PublicResults from '../scenes/Pages/publicresults/IndexResults.js';
import SeriesIndexv2 from '../scenes/Pages/publicresults/SeriesIndexv2.js';
import Document360Widget from "./Document360.js";
import { useLocation } from "react-router-dom";
import ClubsList from '../scenes/Pages/Configuration/Club/ClubsList.js';

const primaryColor = getComputedStyle(document.documentElement)
  .getPropertyValue("--ty-primary-color")
  .trim();

const theme = createTheme({
  typography: {
    fontFamily: "var(--ty-font-family)",
  },
  palette: {
    primary: {
      main: primaryColor,
    },
  },
});

const Overlay = styled("div")(({ theme, open }) => ({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(25, 49, 76, 0.50)",
  zIndex: theme.zIndex.drawer - 1,
  display: open ? "block" : "none",
  pointerEvents: open ? "auto" : "none",
  [theme.breakpoints.up("lg")]: {
    display: "none",
  },
}));


export default function DefaultLayout() {
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const [open, setOpen] = React.useState(!matches);
  const [btnClick, setBtnClick] = React.useState(matches);

  const [isLoggedIn, setIsLoggedIn] = React.useState(localStorage.getItem('accessToken') ? true : false);

  // Wrap setOpen so every sidebar toggle first emits an event. Listeners (e.g.
  // the Finish Times grids) can then pin their layout BEFORE the main content
  // reflows, keeping the toggle smooth on heavy grids.
  const handleToggleDrawer = React.useCallback((next) => {
    window.dispatchEvent(new Event("ty-sidebar-toggle"));
    setOpen(next);
  }, []);

  const routedContent = React.useMemo(() => <RouterProvider />, []);

  if (!isLoggedIn) {
    return (<BrowserRouter>
      <Routes>
        <Route path="/*" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/publicresults/IndexResults" element={<PublicResults />} />
        <Route path="/publicresults/SeriesIndex" element={<SeriesIndexv2 isLoggedOutMode={true} />} />
      </Routes>
    </BrowserRouter>)
  }
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/configuration/club/clubsList" element={< ClubsList />} />
          <Route path="/FinishTable22" element={<FinishTable2 />} />
          <Route path="/finish-time-entry" element={< FinishRaceManager />} />
          {/* Always render the new page inside the sidebar shell */}
          <Route path="/finish-time-entry" element={<Navigate to="/raceday/finish-time-entry" replace />} />
          <Route
            path="/*"
            element={
              <Box sx={{ display: "flex" }} className="ty_application_design">
                <CssBaseline />
                <Sidebar
                  btnClickState={btnClick}
                  btnClickToggle={setBtnClick}
                  drawerState={open}
                  toggleDrawer={handleToggleDrawer}
                  matches={matches}
                />
                <Overlay open={open} onClick={() => {
                  handleToggleDrawer(false);
                }} />
                <Box
                  component="main"
                  sx={matches && open && { pointerEvents: "none" }}
                >
                  <Box component="section" className="main_Pages_box">
                    <Box className="main_Pages_box_inner">
                      <Box
                        component="div"
                        sx={{
                          paddingRight: "0px",
                          height: "100%",
                        }}
                      >
                        {routedContent}
                      </Box>
                    </Box>
                  </Box>
                </Box>

              </Box>
            }
          />

        </Routes>
      </BrowserRouter>
      {/* <Document360Widget specificUrl={pathname} apiKey={"g9S9cSkgviRFPxzNbQS92B84/BNAAs7hz6dJI5YDOXhxUFVg5d7i2b3hGG6WSmFIx9hTI1RohCJOG9SiVQyLousF86TPAYaCsmxVOlgIs7MiVnu4IAqGkVFinybKEEdyehKXx11yh/w7F/qQz854iA=="}/> */}
    </ThemeProvider>
  );
}